<template>
	<v-card-text class="pa-3 post-info d-flex justify-center">
		<v-list light v-if="isLive" class="d-flex pa-0">
			<v-tooltip bottom v-for="(item, index) in postInfo(post)" :key="index">
				<v-list-tile slot="activator">
					<v-list-tile-action class="no-min-width mr-2">
						<v-icon v-bind:class="`${item.color}--text`">
							{{
							item.icon
							}}
						</v-icon>
					</v-list-tile-action>
					<v-list-tile-content v-bind:class="`${item.color}--text info-value`">
						<v-list-tile-title>
							{{
							normalizeNumber(item.value)
							}}
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				<span>{{ item.value }} {{ item.type }}</span>
			</v-tooltip>
		</v-list>
	</v-card-text>
</template>

<script>
import { __normalizeNumber } from "@/utils";
export default {
	name: "AnalyticsElFooter",
	props: ["post", "isLive"],
	methods: {
		normalizeNumber(num) {
			return __normalizeNumber(num);
		},
		postInfo(post) {
			return [
				{
					icon: "favorite",
					value: post.likeCount ? post.likeCount.N : 0,
					color: "pink",
					type: "likes"
				},
				{
					icon: "share",
					value: post.shares ? post.shares.N : 0,
					color: "teal",
					type: "shares"
				},
				{
					icon: "visibility",
					value: post.views ? post.views.N : 0,
					color: "grey",
					type: "views"
				}
			];
		}
	}
};
</script>

<style>
.no-min-width {
	min-width: 0;
}
.post-info .icon {
	font-size: 28px;
}
.post-info .info-value {
	font-size: 17px;
}
</style>
